<!-- Este componente serve tanto para Cross Sell quanto para Dynamic Rule -->
<template>
  <offer-sale-base :offer-sale="offerSale" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="productInfoItems" />
    </template>

    <template v-slot:line-2>
      <offer-sale-line :line-items="quantityItem" />
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'

export default {
  name: 'IndustryComboSaleTrigger',
  components: {
    OfferSaleBase,
    OfferSaleLine,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    triggerAmount: {
      type: Number,
      required: true,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    quantityItem() {
      return [
        {
          label: 'Quantidade',
          value: this.triggerAmount,
          format: 'text',
        },
      ]
    },
  },
}
</script>
